import { useLocation } from 'react-router-dom'
import { LANGUAGES } from '@shared/i18n/languages'
import { useLang } from '@shared/i18n/useLang'

export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const lang = useLang()
  const { pathname } = useLocation()

  function switchTo(code: string) {
    const rest = pathname.replace(/^\/(ru|zh)/, '')
    // Full reload (not client-side navigate) — content pages fetch by slug from
    // WordPress, and a SPA transition can leave stale/mismatched data behind
    // when switching language on the same route.
    window.location.href = `/${code}${rest === '' ? '' : rest}`
  }

  return (
    <div style={{ display: 'flex', gap: 4 }}>
      {LANGUAGES.map(l => (
        <button
          key={l.code}
          type="button"
          onClick={() => switchTo(l.code)}
          style={{
            fontSize: compact ? 13 : 11, fontWeight: 600, letterSpacing: '.05em',
            padding: compact ? '8px 12px' : '6px 10px', borderRadius: 3, cursor: 'pointer',
            background: lang === l.code ? '#189BD5' : 'transparent',
            color: lang === l.code ? '#FFFFFF' : '#93A3AE',
            border: `1px solid ${lang === l.code ? '#189BD5' : '#3A434D'}`,
            transition: 'all .15s',
          }}
        >
          {l.label}
        </button>
      ))}
    </div>
  )
}
